import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";

import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";

import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import Button from "../../components/Buttons";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import ImageUploader from "../../components/upload-image";
import { useNavigate } from "react-router-dom";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const navigate = useNavigate();
  const {
    initialValues,
    handleSubmit,
    serviceListArray,
    handleServiceDelete,
    ourValueArray,
    handleValuesDelete,
    handleValuesAdd,
    awardsAndRecognitionListArray,
    handleAwardDelete,
    handleAwardsAdd,
  } = usePageProvider();

  return (
    <Section>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" alwaysOpen>
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.meta_title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.keywords" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.meta_description" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.description"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput name="banner.cta" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA Redirect Link"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.cta_redirect_link"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label
                        label="Banner Video"
                        className="mb-2 text-black text-[15px]"
                      />
                      <ImageUploader
                        className="w-full"
                        title="video"
                        name="banner.banner_video"
                        imageUrl={values?.banner?.banner_video}
                        onChange={(res) => {
                          setFieldValue(`banner.banner_video`, res?.data?.file_url);
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA "
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput name="banner.cto_label" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Services</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="services.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="services.subheading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Banner"
                        className="mb-2 text-black text-[15px]"
                      />
                      <ImageUploader
                        imgStyle={{ width: "12rem" }}
                        imageUrl={values?.services?.image}
                        onChange={(res) => {
                          setFieldValue("services.image", res?.data?.file_url);
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex justify-end "
                  >
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer ">
                      <Plus onClick={() => navigate("/add-service/add")} className={" text-[white]"} />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            SubHeading
                          </th>
                          {values?.services?.servicesList?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-1 text-center">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="services.servicesList"
                          render={(arrayHelper) => {
                            serviceListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.services?.servicesList?.map(
                                  (item, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                      <td className="border border-gray-300 px-3 py-3 text-black font-medium">
                                        {item.heading || "-"}
                                      </td>
                                      <td className="border border-gray-300 px-3 py-3 text-gray-500 text-sm max-w-[400px] truncate">
                                        {item.description || "-"}
                                      </td>
                                      {values?.services?.servicesList?.length >
                                        0 && (
                                          <td className="border border-gray-300 bg-white px-4 py-3 text-center">
                                            <div className="flex items-center justify-center space-x-3">
                                              <Pencil
                                                className="cursor-pointer text-gray-700 hover:text-black w-4 h-4"
                                                onClick={() => {
                                                  const serviceId = item._id || index;
                                                  navigate(`/add-service/${serviceId}`);
                                                }}
                                              />
                                              <Trash
                                                className="cursor-pointer text-red-600 hover:text-red-800 w-4 h-4"
                                                onClick={handleServiceDelete(index)}
                                              />
                                            </div>
                                          </td>
                                        )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>Our Values</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="ourValue.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="ourValue.subheading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end" >
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer">
                      <Plus onClick={handleValuesAdd} className={" text-[white]"} />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            SubHeading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Logo
                          </th>
                          {values?.ourValue.ourValueTable?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="ourValue.ourValueTable"
                          render={(arrayHelper) => {
                            ourValueArray.current = arrayHelper;
                            return (
                              <>
                                {values?.ourValue.ourValueTable?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-2 py-2">
                                        <FormikInput
                                          name={`ourValue.ourValueTable.${index}.heading`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <FormikInput
                                          name={`ourValue.ourValueTable.${index}.subheading`}
                                          rootClassName="w-full" as="textarea"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <ImageUploader
                                          imgStyle={{ width: "8rem" }}
                                          imageUrl={
                                            values?.ourValue?.ourValueTable?.[
                                              index
                                            ]?.logo
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `ourValue.ourValueTable.${index}.logo`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      {values?.ourValue?.ourValueTable?.length >
                                        0 && (
                                          <td
                                            className="border border-gray-300 bg-white px-4 py-2 cursor-pointer text-center"
                                            onClick={handleValuesDelete(index)}>
                                            <Trash className="mx-auto" />
                                          </td>
                                        )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5">
                <Accordion.Header>Awards & Recognition</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="awardsAndRecognition.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="awardsAndRecognition.subheading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div
                    className="flex justify-end "
                  >
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto  cursor-pointer ">
                      <Plus onClick={handleAwardsAdd} className={" text-[white]"} />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left  ">
                            SubHeading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Logo
                          </th>
                          {values?.awardsAndRecognition
                            ?.awardsAndRecognitionList?.length > 0 && (
                              <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                                Action
                              </th>
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="awardsAndRecognition.awardsAndRecognitionList"
                          render={(arrayHelper) => {
                            awardsAndRecognitionListArray.current = arrayHelper;

                            return (
                              <>
                                {values?.awardsAndRecognition?.awardsAndRecognitionList?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-2 py-2">
                                        <FormikInput
                                          name={`awardsAndRecognition.awardsAndRecognitionList.${index}.heading`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <FormikInput
                                          name={`awardsAndRecognition.awardsAndRecognitionList.${index}.subheading`}
                                          rootClassName="w-full" as="textarea"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <ImageUploader
                                          imgStyle={{ width: "8rem" }}
                                          imageUrl={
                                            values?.awardsAndRecognition
                                              ?.awardsAndRecognitionList?.[
                                              index
                                            ]?.logo
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `awardsAndRecognition.awardsAndRecognitionList.${index}.logo`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      {values?.awardsAndRecognition
                                        ?.awardsAndRecognitionList?.length >
                                        0 && (
                                          <td
                                            className="border border-gray-300 bg-white px-4 py-2 cursor-pointer text-center"
                                            onClick={handleAwardDelete(index)}>
                                            <Trash className="mx-auto" />
                                          </td>
                                        )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="6">
                <Accordion.Header>Catalog</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="catalog_download.title"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="File"
                        className="mb-2 text-black text-[15px]"
                      />

                      <ImageUploader
                        className="w-full"
                        title="File"
                        name="catalog_download.file"
                        imageUrl={values?.catalog_download?.file}
                        onChange={(res) => {
                          setFieldValue(
                            `catalog_download.file`,
                            res?.data?.file_url
                          );
                        }}
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}

              <Accordion.Item eventKey="7" className="mb-10">
                <Accordion.Header>Brochure</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="brochure_download.title"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="File"
                        className="mb-2 text-black text-[15px]"
                      />
                      <ImageUploader
                        className="w-full"
                        title="File"
                        name="brochure_download.file"
                        imageUrl={values?.brochure_download?.file}
                        onChange={(res) => {
                          setFieldValue(
                            `brochure_download.file`,
                            res?.data?.file_url
                          );
                        }}
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
